import {fetch} from "utils/dataAccess";

/**
 * Average e-commerce scoring of a retailer's scored products, aggregated by
 * Elasticsearch over the whole retailer — filters and pagination never change
 * it, so one call per page visit is enough. Zeroes when no product is scored.
 *
 * @param retailerId {string} bare uuid, without the /retailers/ prefix
 * @returns {Promise<{averageScore: number, averagePotentialScore: number, scoredProducts: number}>}
 */
export default function scoringSummary(retailerId) {
    return fetch(`/retailers/${retailerId}/products/scoring-summary`)
        .then((response) => response.json());
}
